<template>
  <div>
    NotFound
  </div>
</template>

<script>
export default {
  name: 'NotFound',
};
</script>
